

// V1 without validation
// import React from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   Container,
//   Paper, 
//   Stack,
// } from "@mui/material";
// import TwoFieldRow from "./twoFieldsRow";
// import UploadWithLabel from "./uploadWithLable";
// import { Formik, Form, FieldArray, useFormikContext } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";

// const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB in bytes

// const loanValidationSchema = (t) =>
//   Yup.object({
//     loans: Yup.array()
//       .of(
//         Yup.object({
//           loan_account_no: Yup.string().required(t("loans.validation.loanAccountNoRequired")),
//           loan_amt_borrowed: Yup.number()
//             .typeError(t("loans.validation.mustBeNumber"))
//             .required(t("loans.validation.loanAmtBorrowedRequired")),
//           loan_amt_paid: Yup.number()
//             .typeError(t("loans.validation.mustBeNumber"))
//             .required(t("loans.validation.loanAmtPaidRequired"))
//             .test(
//               "paid-not-greater-than-borrowed",
//               t("loans.validation.paidNotGreaterThanBorrowed"),
//               function (value) {
//                 const { loan_amt_borrowed } = this.parent;
//                 return value <= loan_amt_borrowed;
//               }
//             ),
//           loan_amt_remaining: Yup.number()
//             .typeError(t("loans.validation.mustBeNumber"))
//             .required(t("loans.validation.loanAmtRemainingRequired")),
//           loan_closed_date: Yup.string().required(t("loans.validation.loanClosedDateRequired")),
//           loan_proof: Yup.mixed()
//             .required(t("loans.validation.loanProofRequired"))
//             .test(
//               "fileExists",
//               t("loans.validation.loanProofRequired"),
//               (value) => value && typeof value.name === "string" && value.name.length > 0
//             )
//             .test(
//               "fileSize",
//               t("baseInfo.validation.fileSizeExceeded") || "File size must be less than 2MB",
//               (value) => !value || (value.size && value.size <= MAX_FILE_SIZE)
//             ),
//         })
//       )
//       .min(1, t("loans.validation.oneLoanRequired")),
//   });

// const TotalRemainingWatcher = ({ onTotalRemainingChange }) => {
//   const { values } = useFormikContext();

//   React.useEffect(() => {
//     if (values.loans) {
//       const totalRemaining = values.loans.reduce(
//         (sum, loan) => sum + (Number(loan.loan_amt_remaining) || 0),
//         0
//       );
//       if (onTotalRemainingChange) {
//         onTotalRemainingChange(totalRemaining);
//       }
//     }
//   }, [values.loans, onTotalRemainingChange]);

//   return null;
// };

// const LoansSection = ({
//   loans,
//   setLoans,
//   activeTab,
//   setActiveTab,
//   onTotalRemainingChange,
// }) => {
//   const { t } = useTranslation();

//   return (
//     <Formik
//       initialValues={{ loans }}
//       validationSchema={loanValidationSchema(t)}
//       enableReinitialize
//       onSubmit={(values, { setSubmitting }) => {
//         setLoans(values.loans);
//         setSubmitting(false);
//         setActiveTab(activeTab + 1);
//       }}
//     >
//       {({
//         values,
//         errors,
//         touched,
//         handleChange,
//         handleBlur,
//         setFieldValue,
//         setFieldTouched,
//       }) => {
//         const handleAmtChange = (e, index, field) => {
//           handleChange(e);
//           const borrowed =
//             field === "loan_amt_borrowed"
//               ? e.target.value
//               : values.loans[index].loan_amt_borrowed;
//           const paid =
//             field === "loan_amt_paid"
//               ? e.target.value
//               : values.loans[index].loan_amt_paid;
//           const remaining = (Number(borrowed) || 0) - (Number(paid) || 0);
//           setFieldValue(
//             `loans[${index}].loan_amt_remaining`,
//             remaining >= 0 ? remaining : 0
//           );
//         };

//         const totalBorrowed = values.loans.reduce(
//           (sum, loan) => sum + (Number(loan.loan_amt_borrowed) || 0),
//           0
//         );
//         const totalPaid = values.loans.reduce(
//           (sum, loan) => sum + (Number(loan.loan_amt_paid) || 0),
//           0
//         );
//         const totalRemaining = values.loans.reduce(
//           (sum, loan) => sum + (Number(loan.loan_amt_remaining) || 0),
//           0
//         );

//         return (
//           <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//             <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//               <Form noValidate>
//                 <Stack spacing={3}>
//                   <TotalRemainingWatcher
//                     onTotalRemainingChange={onTotalRemainingChange}
//                   />

//                   <FieldArray name="loans">
//                     {({ remove, push }) => (
//                       <>
//                         {values.loans.map((loan, i) => (
//                           <Box
//                             key={i}
//                             mb={2}
//                             p={2}
//                             sx={{ border: "1px solid #ccc", borderRadius: 2 }}
//                           >
//                             <TwoFieldRow>
//                               <TextField
//                                 label={t("loans.labels.loanAccountNo")}
//                                 name={`loans[${i}].loan_account_no`}
//                                 value={loan.loan_account_no}
//                                 onChange={handleChange}
//                                 onBlur={handleBlur}
//                                 error={
//                                   touched.loans?.[i]?.loan_account_no &&
//                                   Boolean(errors.loans?.[i]?.loan_account_no)
//                                 }
//                                 helperText={
//                                   touched.loans?.[i]?.loan_account_no &&
//                                   errors.loans?.[i]?.loan_account_no
//                                 }
//                                 fullWidth
//                               />
//                               <TextField
//                                 label={t("loans.labels.loanAmtBorrowed")}
//                                 name={`loans[${i}].loan_amt_borrowed`}
//                                 value={loan.loan_amt_borrowed}
//                                 onChange={(e) =>
//                                   handleAmtChange(e, i, "loan_amt_borrowed")
//                                 }
//                                 onBlur={handleBlur}
//                                 error={
//                                   touched.loans?.[i]?.loan_amt_borrowed &&
//                                   Boolean(errors.loans?.[i]?.loan_amt_borrowed)
//                                 }
//                                 helperText={
//                                   touched.loans?.[i]?.loan_amt_borrowed &&
//                                   errors.loans?.[i]?.loan_amt_borrowed
//                                 }
//                                 fullWidth
//                               />
//                             </TwoFieldRow>
//                             <TwoFieldRow>
//                               <TextField
//                                 label={t("loans.labels.loanAmtPaid")}
//                                 name={`loans[${i}].loan_amt_paid`}
//                                 value={loan.loan_amt_paid}
//                                 onChange={(e) =>
//                                   handleAmtChange(e, i, "loan_amt_paid")
//                                 }
//                                 onBlur={handleBlur}
//                                 error={
//                                   touched.loans?.[i]?.loan_amt_paid &&
//                                   Boolean(errors.loans?.[i]?.loan_amt_paid)
//                                 }
//                                 helperText={
//                                   touched.loans?.[i]?.loan_amt_paid &&
//                                   errors.loans?.[i]?.loan_amt_paid
//                                 }
//                                 fullWidth
//                               />
//                               <TextField
//                                 label={t("loans.labels.loanAmtRemaining")}
//                                 name={`loans[${i}].loan_amt_remaining`}
//                                 value={loan.loan_amt_remaining}
//                                 InputProps={{ readOnly: true }}
//                                 error={
//                                   touched.loans?.[i]?.loan_amt_remaining &&
//                                   Boolean(errors.loans?.[i]?.loan_amt_remaining)
//                                 }
//                                 helperText={
//                                   touched.loans?.[i]?.loan_amt_remaining &&
//                                   errors.loans?.[i]?.loan_amt_remaining
//                                 }
//                                 fullWidth
//                               />
//                             </TwoFieldRow>
//                             <TwoFieldRow>
//                               <TextField
//                                 type="date"
//                                 label={t("loans.labels.loanClosedDate")}
//                                 name={`loans[${i}].loan_closed_date`}
//                                 value={loan.loan_closed_date}
//                                 onChange={handleChange}
//                                 onBlur={handleBlur}
//                                 InputLabelProps={{ shrink: true }}
//                                 error={
//                                   touched.loans?.[i]?.loan_closed_date &&
//                                   Boolean(errors.loans?.[i]?.loan_closed_date)
//                                 }
//                                 helperText={
//                                   touched.loans?.[i]?.loan_closed_date &&
//                                   errors.loans?.[i]?.loan_closed_date
//                                 }
//                                 fullWidth
//                               />
//                               <Box sx={{ flex: 1 }}>
//                                 <UploadWithLabel
//                                   label={t("loans.labels.uploadLoanDocs")}
//                                   name={`loans[${i}].loan_proof`}
//                                   onChange={(e) => {
//                                     setFieldValue(
//                                       `loans[${i}].loan_proof`,
//                                       e.currentTarget.files[0]
//                                     );
//                                     setFieldTouched(
//                                       `loans[${i}].loan_proof`,
//                                       true
//                                     );
//                                   }}
//                                   file={loan.loan_proof}
//                                   error={
//                                     touched.loans?.[i]?.loan_proof &&
//                                     Boolean(errors.loans?.[i]?.loan_proof)
//                                   }
//                                   helperText={
//                                     touched.loans?.[i]?.loan_proof &&
//                                     errors.loans?.[i]?.loan_proof
//                                   }
//                                 />
//                               </Box>
//                             </TwoFieldRow>
//                             <Button
//                               variant="outlined"
//                               color="error"
//                               onClick={() => remove(i)}
//                               sx={{ mt: 1 }}
//                             >
//                               {t("loans.buttons.remove")}
//                             </Button>
//                           </Box>
//                         ))}
//                         <Button
//                           variant="contained"
//                           sx={{ mt: 2 }}
//                           onClick={() =>
//                             push({
//                               loan_account_no: "",
//                               loan_amt_borrowed: "",
//                               loan_amt_paid: "",
//                               loan_amt_remaining: "",
//                               loan_closed_date: "",
//                               loan_proof: null,
//                             })
//                           }
//                         >
//                           {t("loans.buttons.addLoan")}
//                         </Button>

//                         <Box
//                           sx={{
//                             mt: 4,
//                             p: 2,
//                             border: "1px solid #999",
//                             borderRadius: 2,
//                             backgroundColor: "#f9f9f9",
//                           }}
//                         >
//                           <Typography variant="h6" gutterBottom>
//                             {t("loans.summary.title")}
//                           </Typography>
//                           <TwoFieldRow>
//                             <TextField
//                               label={t("loans.summary.totalBorrowed")}
//                               value={totalBorrowed.toFixed(2)}
//                               InputProps={{ readOnly: true }}
//                               fullWidth
//                             />
//                             <TextField
//                               label={t("loans.summary.totalPaid")}
//                               value={totalPaid.toFixed(2)}
//                               InputProps={{ readOnly: true }}
//                               fullWidth
//                             />
//                           </TwoFieldRow>
//                           <Box mt={2}>
//                             <TextField
//                               label={t("loans.summary.totalRemaining")}
//                               value={totalRemaining.toFixed(2)}
//                               InputProps={{ readOnly: true }}
//                               fullWidth
//                             />
//                           </Box>
//                         </Box>
//                       </>
//                     )}
//                   </FieldArray>

//                   <Box
//                     sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
//                   >
//                     <Button
//                       variant="outlined"
//                       onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}
//                     >
//                       {t("loans.buttons.back")}
//                     </Button>

//                     <Box sx={{ display: "flex", gap: 1 }}>
//                       <Button
//                         variant="text"
//                         color="secondary"
//                         onClick={() => setActiveTab(activeTab + 1)}
//                       >
//                         {t("loans.buttons.skip")}
//                       </Button>
//                       <Button type="submit" variant="contained">
//                         {t("loans.buttons.next")}
//                       </Button>
//                     </Box>
//                   </Box>
//                 </Stack>
//               </Form>
//             </Paper>
//           </Container>
//         );
//       }}
//     </Formik>
//   );
// };

// export default LoansSection;


// V2 with validation
// import React from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   Container,
//   Paper,
//   Stack,
// } from "@mui/material";
// import TwoFieldRow from "./twoFieldsRow";
// import UploadWithLabel from "./uploadWithLable";
// import { Formik, Form, FieldArray, useFormikContext } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";

// const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB in bytes

// const loanValidationSchema = (t) =>
//   Yup.object({
//     loans: Yup.array()
//       .of(
//         Yup.object({
//           loan_account_no: Yup.string().required(t("loans.validation.loanAccountNoRequired")),
//           loan_amt_borrowed: Yup.number()
//             .typeError(t("loans.validation.mustBeNumber"))
//             .required(t("loans.validation.loanAmtBorrowedRequired")),
//           loan_amt_paid: Yup.number()
//             .typeError(t("loans.validation.mustBeNumber"))
//             .required(t("loans.validation.loanAmtPaidRequired"))
//             .test(
//               "paid-not-greater-than-borrowed",
//               t("loans.validation.paidNotGreaterThanBorrowed"),
//               function (value) {
//                 const { loan_amt_borrowed } = this.parent;
//                 return value <= loan_amt_borrowed;
//               }
//             ),
//           loan_amt_remaining: Yup.number()
//             .typeError(t("loans.validation.mustBeNumber"))
//             .required(t("loans.validation.loanAmtRemainingRequired")),
//           loan_closed_date: Yup.string()
//             .required(t("loans.validation.loanClosedDateRequired"))
//             .test(
//               "not-future-date",
//               t("loans.validation.loanClosedDateNotFuture") || "Closure date cannot be in the future",
//               function (value) {
//                 if (!value) return true;
//                 const today = new Date();
//                 today.setHours(0, 0, 0, 0);
//                 const selectedDate = new Date(value);
//                 selectedDate.setHours(0, 0, 0, 0);
//                 return selectedDate <= today;
//               }
//             ),
//           loan_proof: Yup.mixed()
//             .required(t("loans.validation.loanProofRequired"))
//             .test(
//               "fileExists",
//               t("loans.validation.loanProofRequired"),
//               (value) => value && typeof value.name === "string" && value.name.length > 0
//             )
//             .test(
//               "fileType",
//               t("loans.validation.invalidFileType") || "Only PDF files are allowed",
//               (value) => {
//                 if (!value || !value.name) return true;
//                 return value.name.toLowerCase().endsWith('.pdf');
//               }
//             )
//             .test(
//               "fileSize",
//               t("baseInfo.validation.fileSizeExceeded") || "File size must be less than 2MB",
//               (value) => !value || (value.size && value.size <= MAX_FILE_SIZE)
//             ),
//         })
//       )
//       .min(1, t("loans.validation.oneLoanRequired")),
//   });

// const TotalRemainingWatcher = ({ onTotalRemainingChange }) => {
//   const { values } = useFormikContext();

//   React.useEffect(() => {
//     if (values.loans) {
//       const totalRemaining = values.loans.reduce(
//         (sum, loan) => sum + (Number(loan.loan_amt_remaining) || 0),
//         0
//       );
//       if (onTotalRemainingChange) {
//         onTotalRemainingChange(totalRemaining);
//       }
//     }
//   }, [values.loans, onTotalRemainingChange]);

//   return null;
// };

// const LoansSection = ({
//   loans,
//   setLoans,
//   activeTab,
//   setActiveTab,
//   onTotalRemainingChange,
// }) => {
//   const { t } = useTranslation();

//   return (
//     <Formik
//       initialValues={{ loans }}
//       validationSchema={loanValidationSchema(t)}
//       enableReinitialize
//       onSubmit={(values, { setSubmitting }) => {
//         setLoans(values.loans);
//         setSubmitting(false);
//         setActiveTab(activeTab + 1);
//       }}
//     >
//       {({
//         values,
//         errors,
//         touched,
//         handleChange,
//         handleBlur,
//         setFieldValue,
//         setFieldTouched,
//       }) => {
//         const handleAmtChange = (e, index, field) => {
//           handleChange(e);
//           const borrowed =
//             field === "loan_amt_borrowed"
//               ? e.target.value
//               : values.loans[index].loan_amt_borrowed;
//           const paid =
//             field === "loan_amt_paid"
//               ? e.target.value
//               : values.loans[index].loan_amt_paid;
//           const remaining = (Number(borrowed) || 0) - (Number(paid) || 0);
//           setFieldValue(
//             `loans[${index}].loan_amt_remaining`,
//             remaining >= 0 ? remaining : 0
//           );
//         };

//         const totalBorrowed = values.loans.reduce(
//           (sum, loan) => sum + (Number(loan.loan_amt_borrowed) || 0),
//           0
//         );
//         const totalPaid = values.loans.reduce(
//           (sum, loan) => sum + (Number(loan.loan_amt_paid) || 0),
//           0
//         );
//         const totalRemaining = values.loans.reduce(
//           (sum, loan) => sum + (Number(loan.loan_amt_remaining) || 0),
//           0
//         );

//         return (
//           <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//             <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//               <Form noValidate>
//                 <Stack spacing={3}>
//                   <TotalRemainingWatcher
//                     onTotalRemainingChange={onTotalRemainingChange}
//                   />

//                   <FieldArray name="loans">
//                     {({ remove, push }) => (
//                       <>
//                         {values.loans.map((loan, i) => (
//                           <Box
//                             key={i}
//                             mb={2}
//                             p={2}
//                             sx={{ border: "1px solid #ccc", borderRadius: 2 }}
//                           >
//                             <TwoFieldRow>
//                               <TextField
//                                 label={t("loans.labels.loanAccountNo")}
//                                 name={`loans[${i}].loan_account_no`}
//                                 value={loan.loan_account_no}
//                                 onChange={handleChange}
//                                 onBlur={handleBlur}
//                                 error={
//                                   touched.loans?.[i]?.loan_account_no &&
//                                   Boolean(errors.loans?.[i]?.loan_account_no)
//                                 }
//                                 helperText={
//                                   touched.loans?.[i]?.loan_account_no &&
//                                   errors.loans?.[i]?.loan_account_no
//                                 }
//                                 fullWidth
//                               />
//                               <TextField
//                                 label={t("loans.labels.loanAmtBorrowed")}
//                                 name={`loans[${i}].loan_amt_borrowed`}
//                                 value={loan.loan_amt_borrowed}
//                                 onChange={(e) =>
//                                   handleAmtChange(e, i, "loan_amt_borrowed")
//                                 }
//                                 onBlur={handleBlur}
//                                 error={
//                                   touched.loans?.[i]?.loan_amt_borrowed &&
//                                   Boolean(errors.loans?.[i]?.loan_amt_borrowed)
//                                 }
//                                 helperText={
//                                   touched.loans?.[i]?.loan_amt_borrowed &&
//                                   errors.loans?.[i]?.loan_amt_borrowed
//                                 }
//                                 fullWidth
//                               />
//                             </TwoFieldRow>
//                             <TwoFieldRow>
//                               <TextField
//                                 label={t("loans.labels.loanAmtPaid")}
//                                 name={`loans[${i}].loan_amt_paid`}
//                                 value={loan.loan_amt_paid}
//                                 onChange={(e) =>
//                                   handleAmtChange(e, i, "loan_amt_paid")
//                                 }
//                                 onBlur={handleBlur}
//                                 error={
//                                   touched.loans?.[i]?.loan_amt_paid &&
//                                   Boolean(errors.loans?.[i]?.loan_amt_paid)
//                                 }
//                                 helperText={
//                                   touched.loans?.[i]?.loan_amt_paid &&
//                                   errors.loans?.[i]?.loan_amt_paid
//                                 }
//                                 fullWidth
//                               />
//                               <TextField
//                                 label={t("loans.labels.loanAmtRemaining")}
//                                 name={`loans[${i}].loan_amt_remaining`}
//                                 value={loan.loan_amt_remaining}
//                                 InputProps={{ readOnly: true }}
//                                 error={
//                                   touched.loans?.[i]?.loan_amt_remaining &&
//                                   Boolean(errors.loans?.[i]?.loan_amt_remaining)
//                                 }
//                                 helperText={
//                                   touched.loans?.[i]?.loan_amt_remaining &&
//                                   errors.loans?.[i]?.loan_amt_remaining
//                                 }
//                                 fullWidth
//                               />
//                             </TwoFieldRow>
//                             <TwoFieldRow>
//                               <TextField
//                                 type="date"
//                                 label={t("loans.labels.loanClosedDate")}
//                                 name={`loans[${i}].loan_closed_date`}
//                                 value={loan.loan_closed_date}
//                                 onChange={handleChange}
//                                 onBlur={handleBlur}
//                                 InputLabelProps={{ shrink: true }}
//                                 error={
//                                   touched.loans?.[i]?.loan_closed_date &&
//                                   Boolean(errors.loans?.[i]?.loan_closed_date)
//                                 }
//                                 helperText={
//                                   touched.loans?.[i]?.loan_closed_date &&
//                                   errors.loans?.[i]?.loan_closed_date
//                                 }
//                                 fullWidth
//                               />
//                               <Box sx={{ flex: 1 }}>
//                                 <UploadWithLabel
//                                   label={t("loans.labels.uploadLoanDocs")}
//                                   name={`loans[${i}].loan_proof`}
//                                   onChange={(e) => {
//                                     setFieldValue(
//                                       `loans[${i}].loan_proof`,
//                                       e.currentTarget.files[0]
//                                     );
//                                     setFieldTouched(
//                                       `loans[${i}].loan_proof`,
//                                       true
//                                     );
//                                   }}
//                                   file={loan.loan_proof}
//                                   error={
//                                     touched.loans?.[i]?.loan_proof &&
//                                     Boolean(errors.loans?.[i]?.loan_proof)
//                                   }
//                                   helperText={
//                                     touched.loans?.[i]?.loan_proof &&
//                                     errors.loans?.[i]?.loan_proof
//                                   }
//                                 />
//                               </Box>
//                             </TwoFieldRow>
//                             <Button
//                               variant="outlined"
//                               color="error"
//                               onClick={() => remove(i)}
//                               sx={{ mt: 1 }}
//                             >
//                               {t("loans.buttons.remove")}
//                             </Button>
//                           </Box>
//                         ))}
//                         <Button
//                           variant="contained"
//                           sx={{ mt: 2 }}
//                           onClick={() =>
//                             push({
//                               loan_account_no: "",
//                               loan_amt_borrowed: "",
//                               loan_amt_paid: "",
//                               loan_amt_remaining: "",
//                               loan_closed_date: "",
//                               loan_proof: null,
//                             })
//                           }
//                         >
//                           {t("loans.buttons.addLoan")}
//                         </Button>

//                         <Box
//                           sx={{
//                             mt: 4,
//                             p: 2,
//                             border: "1px solid #999",
//                             borderRadius: 2,
//                             backgroundColor: "#f9f9f9",
//                           }}
//                         >
//                           <Typography variant="h6" gutterBottom>
//                             {t("loans.summary.title")}
//                           </Typography>
//                           <TwoFieldRow>
//                             <TextField
//                               label={t("loans.summary.totalBorrowed")}
//                               value={totalBorrowed.toFixed(2)}
//                               InputProps={{ readOnly: true }}
//                               fullWidth
//                             />
//                             <TextField
//                               label={t("loans.summary.totalPaid")}
//                               value={totalPaid.toFixed(2)}
//                               InputProps={{ readOnly: true }}
//                               fullWidth
//                             />
//                           </TwoFieldRow>
//                           <Box mt={2}>
//                             <TextField
//                               label={t("loans.summary.totalRemaining")}
//                               value={totalRemaining.toFixed(2)}
//                               InputProps={{ readOnly: true }}
//                               fullWidth
//                             />
//                           </Box>
//                         </Box>
//                       </>
//                     )}
//                   </FieldArray>

//                   <Box
//                     sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
//                   >
//                     <Button
//                       variant="outlined"
//                       onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}
//                     >
//                       {t("loans.buttons.back")}
//                     </Button>

//                     <Box sx={{ display: "flex", gap: 1 }}>
//                       <Button
//                         variant="text"
//                         color="secondary"
//                         onClick={() => setActiveTab(activeTab + 1)}
//                       >
//                         {t("loans.buttons.skip")}
//                       </Button>
//                       <Button type="submit" variant="contained">
//                         {t("loans.buttons.next")}
//                       </Button>
//                     </Box>
//                   </Box>
//                 </Stack>
//               </Form>
//             </Paper>
//           </Container>
//         );
//       }}
//     </Formik>
//   );
// };

// export default LoansSection;


import React from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Container,
  Paper,
  Stack,
} from "@mui/material";
import TwoFieldRow from "./twoFieldsRow";
import UploadWithLabel from "./uploadWithLable";
import { Formik, Form, FieldArray, useFormikContext } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB in bytes

const loanValidationSchema = (t) =>
  Yup.object({
    loans: Yup.array()
      .of(
        Yup.object({
          loan_account_no: Yup.string().required(t("loans.validation.loanAccountNoRequired")),
          loan_amt_borrowed: Yup.number()
            .typeError(t("loans.validation.mustBeNumber"))
            .required(t("loans.validation.loanAmtBorrowedRequired")),
          loan_amt_paid: Yup.number()
            .typeError(t("loans.validation.mustBeNumber"))
            .required(t("loans.validation.loanAmtPaidRequired"))
            .test(
              "paid-not-greater-than-borrowed",
              t("loans.validation.paidNotGreaterThanBorrowed"),
              function (value) {
                const { loan_amt_borrowed } = this.parent;
                return value <= loan_amt_borrowed;
              }
            ),
          loan_amt_remaining: Yup.number()
            .typeError(t("loans.validation.mustBeNumber"))
            .required(t("loans.validation.loanAmtRemainingRequired")),
          loan_closed_date: Yup.string()
            .required(t("loans.validation.loanClosedDateRequired"))
            .test(
              "not-future-date",
              t("loans.validation.loanClosedDateNotFuture") || "Closure date cannot be in the future",
              function (value) {
                if (!value) return true;
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const selectedDate = new Date(value);
                selectedDate.setHours(0, 0, 0, 0);
                return selectedDate <= today;
              }
            ),
          loan_proof: Yup.mixed()
            .required(t("loans.validation.loanProofRequired"))
            .test(
              "fileExists",
              t("loans.validation.loanProofRequired"),
              (value) => value && typeof value.name === "string" && value.name.length > 0
            )
            .test(
              "fileType",
              t("loans.validation.invalidFileType") || "Only PDF files are allowed",
              (value) => {
                if (!value || !value.name) return true;
                return value.name.toLowerCase().endsWith('.pdf');
              }
            )
            .test(
              "fileSize",
              t("baseInfo.validation.fileSizeExceeded") || "File size must be less than 2MB",
              (value) => !value || (value.size && value.size <= MAX_FILE_SIZE)
            ),
        })
      )
      .min(1, t("loans.validation.oneLoanRequired")),
  });

const TotalRemainingWatcher = ({ onTotalRemainingChange }) => {
  const { values } = useFormikContext();

  React.useEffect(() => {
    if (values.loans) {
      const totalRemaining = values.loans.reduce(
        (sum, loan) => sum + (Number(loan.loan_amt_remaining) || 0),
        0
      );
      if (onTotalRemainingChange) {
        onTotalRemainingChange(totalRemaining);
      }
    }
  }, [values.loans, onTotalRemainingChange]);

  return null;
};

const LoansSection = ({
  loans,
  setLoans,
  activeTab,
  setActiveTab,
  onTotalRemainingChange,
}) => {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={{ loans }}
      validationSchema={loanValidationSchema(t)}
      enableReinitialize
      onSubmit={(values, { setSubmitting }) => {
        setLoans(values.loans);
        setSubmitting(false);
        setActiveTab(activeTab + 1);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        setFieldValue,
        setFieldTouched,
      }) => {
        const handleAmtChange = (e, index, field) => {
          handleChange(e);
          const borrowed =
            field === "loan_amt_borrowed"
              ? e.target.value
              : values.loans[index].loan_amt_borrowed;
          const paid =
            field === "loan_amt_paid"
              ? e.target.value
              : values.loans[index].loan_amt_paid;
          const remaining = (Number(borrowed) || 0) - (Number(paid) || 0);
          setFieldValue(
            `loans[${index}].loan_amt_remaining`,
            remaining >= 0 ? remaining : 0
          );
        };

        const totalBorrowed = values.loans.reduce(
          (sum, loan) => sum + (Number(loan.loan_amt_borrowed) || 0),
          0
        );
        const totalPaid = values.loans.reduce(
          (sum, loan) => sum + (Number(loan.loan_amt_paid) || 0),
          0
        );
        const totalRemaining = values.loans.reduce(
          (sum, loan) => sum + (Number(loan.loan_amt_remaining) || 0),
          0
        );

        return (
          <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
            <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
              <Form noValidate>
                <Stack spacing={3}>
                  <TotalRemainingWatcher
                    onTotalRemainingChange={onTotalRemainingChange}
                  />

                  <FieldArray name="loans">
                    {({ remove, push }) => (
                      <>
                        {values.loans.map((loan, i) => (
                          <Box
                            key={i}
                            mb={2}
                            p={2}
                            sx={{ border: "1px solid #ccc", borderRadius: 2 }}
                          >
                            <TwoFieldRow>
                              <TextField
                                label={t("loans.labels.loanAccountNo")}
                                name={`loans[${i}].loan_account_no`}
                                value={loan.loan_account_no}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={
                                  touched.loans?.[i]?.loan_account_no &&
                                  Boolean(errors.loans?.[i]?.loan_account_no)
                                }
                                helperText={
                                  touched.loans?.[i]?.loan_account_no &&
                                  errors.loans?.[i]?.loan_account_no
                                }
                                fullWidth
                              />
                              <TextField
                                label={t("loans.labels.loanAmtBorrowed")}
                                name={`loans[${i}].loan_amt_borrowed`}
                                value={loan.loan_amt_borrowed}
                                onChange={(e) =>
                                  handleAmtChange(e, i, "loan_amt_borrowed")
                                }
                                onBlur={handleBlur}
                                error={
                                  touched.loans?.[i]?.loan_amt_borrowed &&
                                  Boolean(errors.loans?.[i]?.loan_amt_borrowed)
                                }
                                helperText={
                                  touched.loans?.[i]?.loan_amt_borrowed &&
                                  errors.loans?.[i]?.loan_amt_borrowed
                                }
                                fullWidth
                              />
                            </TwoFieldRow>
                            <TwoFieldRow>
                              <TextField
                                label={t("loans.labels.loanAmtPaid")}
                                name={`loans[${i}].loan_amt_paid`}
                                value={loan.loan_amt_paid}
                                onChange={(e) =>
                                  handleAmtChange(e, i, "loan_amt_paid")
                                }
                                onBlur={handleBlur}
                                error={
                                  touched.loans?.[i]?.loan_amt_paid &&
                                  Boolean(errors.loans?.[i]?.loan_amt_paid)
                                }
                                helperText={
                                  touched.loans?.[i]?.loan_amt_paid &&
                                  errors.loans?.[i]?.loan_amt_paid
                                }
                                fullWidth
                              />
                              <TextField
                                label={t("loans.labels.loanAmtRemaining")}
                                name={`loans[${i}].loan_amt_remaining`}
                                value={loan.loan_amt_remaining}
                                InputProps={{ readOnly: true }}
                                error={
                                  touched.loans?.[i]?.loan_amt_remaining &&
                                  Boolean(errors.loans?.[i]?.loan_amt_remaining)
                                }
                                helperText={
                                  touched.loans?.[i]?.loan_amt_remaining &&
                                  errors.loans?.[i]?.loan_amt_remaining
                                }
                                fullWidth
                              />
                            </TwoFieldRow>
                            <TwoFieldRow>
                              <TextField
                                type="date"
                                label={t("loans.labels.loanClosedDate")}
                                name={`loans[${i}].loan_closed_date`}
                                value={loan.loan_closed_date}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                InputLabelProps={{ shrink: true }}
                                error={
                                  touched.loans?.[i]?.loan_closed_date &&
                                  Boolean(errors.loans?.[i]?.loan_closed_date)
                                }
                                helperText={
                                  touched.loans?.[i]?.loan_closed_date &&
                                  errors.loans?.[i]?.loan_closed_date
                                }
                                fullWidth
                              />
                              <Box sx={{ flex: 1 }}>
                                <UploadWithLabel
                                  label={t("loans.labels.uploadLoanDocs")}
                                  name={`loans[${i}].loan_proof`}
                                  onChange={(e) => {
                                    setFieldValue(
                                      `loans[${i}].loan_proof`,
                                      e.currentTarget.files[0]
                                    );
                                    setFieldTouched(
                                      `loans[${i}].loan_proof`,
                                      true
                                    );
                                  }}
                                  file={loan.loan_proof}
                                  error={
                                    touched.loans?.[i]?.loan_proof &&
                                    Boolean(errors.loans?.[i]?.loan_proof)
                                  }
                                  helperText={
                                    touched.loans?.[i]?.loan_proof &&
                                    errors.loans?.[i]?.loan_proof
                                  }
                                />
                                {touched.loans?.[i]?.loan_proof && errors.loans?.[i]?.loan_proof && (
                                  <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                                    {errors.loans[i].loan_proof}
                                  </Typography>
                                )}
                              </Box>
                            </TwoFieldRow>
                            <Button
                              variant="outlined"
                              color="error"
                              onClick={() => remove(i)}
                              sx={{ mt: 1 }}
                            >
                              {t("loans.buttons.remove")}
                            </Button>
                          </Box>
                        ))}
                        <Button
                          variant="contained"
                          sx={{ mt: 2 }}
                          onClick={() =>
                            push({
                              loan_account_no: "",
                              loan_amt_borrowed: "",
                              loan_amt_paid: "",
                              loan_amt_remaining: "",
                              loan_closed_date: "",
                              loan_proof: null,
                            })
                          }
                        >
                          {t("loans.buttons.addLoan")}
                        </Button>

                        <Box
                          sx={{
                            mt: 4,
                            p: 2,
                            border: "1px solid #999",
                            borderRadius: 2,
                            backgroundColor: "#f9f9f9",
                          }}
                        >
                          <Typography variant="h6" gutterBottom>
                            {t("loans.summary.title")}
                          </Typography>
                          <TwoFieldRow>
                            <TextField
                              label={t("loans.summary.totalBorrowed")}
                              value={totalBorrowed.toFixed(2)}
                              InputProps={{ readOnly: true }}
                              fullWidth
                            />
                            <TextField
                              label={t("loans.summary.totalPaid")}
                              value={totalPaid.toFixed(2)}
                              InputProps={{ readOnly: true }}
                              fullWidth
                            />
                          </TwoFieldRow>
                          <Box mt={2}>
                            <TextField
                              label={t("loans.summary.totalRemaining")}
                              value={totalRemaining.toFixed(2)}
                              InputProps={{ readOnly: true }}
                              fullWidth
                            />
                          </Box>
                        </Box>
                      </>
                    )}
                  </FieldArray>

                  <Box
                    sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}
                    >
                      {t("loans.buttons.back")}
                    </Button>

                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Button
                        variant="text"
                        color="secondary"
                        onClick={() => setActiveTab(activeTab + 1)}
                      >
                        {t("loans.buttons.skip")}
                      </Button>
                      <Button 
                        type="submit" 
                        variant="contained"
                        sx={{
                          "&.Mui-disabled": {
                            backgroundColor: "rgba(25, 118, 210, 0.6)",
                            color: "rgba(255, 255, 255, 0.9)",
                            cursor: "not-allowed",
                          },
                        }}
                      >
                        {t("loans.buttons.next")}
                      </Button>
                    </Box>
                  </Box>
                </Stack>
              </Form>
            </Paper>
          </Container>
        );
      }}
    </Formik>
  );
};

export default LoansSection;
